export default __webpack_public_path__ + "static/CookieRunBold.subset.5-170c8f2d808247f65597ebd014916337.woff2";